import { Injectable,  } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManualesService {
  token: string;
  httpOptionsFile;
  httpOptions;
  constructor(private http: HttpClient) {
    this.updateToken();
   }

  URL_InspeccionTotal = `${environment.URL_InspeccionTotal}`;

  updateToken(){
    this.token = localStorage.getItem('token');
    this.httpOptionsFile = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.token
      }),
      reportProgress: true,
      observe: 'events',
    }
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8','Authorization': 'Bearer ' + this.token
      }),
      observe: 'response'
    };
  }
  handleError(error) {
    let errorMessage = '';

    if (error.errors instanceof ErrorEvent) {
      errorMessage = error.error.errors[0].message;
      return throwError(errorMessage);
    }
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  //#region Manuales Operadores
  //Sube un manual y lo guarda en la BD
  uploadManual(formData) {
  this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + "v1/archivosUsuarios/" , formData, this.httpOptionsFile)
    .pipe(
      catchError(this.handleError)
    );
  }
  //Trae todos los manuales guardados en la base de datos (nombre, descripcion e id. NO TRAE los archivos en si)
  getManuales(idCliente:number) {
    this.updateToken();
      return this.http.get(this.URL_InspeccionTotal + "v1/archivosUsuarios/findAll/" + idCliente, this.httpOptions)
    }
  //Descarga un manual
  downloadManual(id:number) {
    this.updateToken();
      return this.http.get(this.URL_InspeccionTotal + "v1/archivosUsuarios/findById/" + id , this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }
  //Borrar un manual de la BD
  deleteManual(id:number) {
    this.updateToken();
      return this.http.delete(this.URL_InspeccionTotal + "v1/archivosUsuarios/" + id, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion
}
